module.exports = __webpack_public_path__ + "d314620974618e5154cfe2ace282a74f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_3_2023_chart.png
// module id = 1678
// module chunks = 0